const HPActionItemCategories =
{
    Loan: 1,
    Setup: 2,
    Compliance: 3,
    Marketing: 4,
};

export default HPActionItemCategories;



// WEBPACK FOOTER //
// ./src/app/config/constants/ActionItemCategoryTypes.constant.js